<template>
  <div id="app">
    <router-view></router-view>
    <footer>
      <cookie-law theme="base"></cookie-law>
    </footer>
  </div>
</template>

<script>
import { BeaconEvent, defaultEventCallbacks } from '@airgap/beacon-sdk'
import { BeaconWallet } from '@taquito/beacon-wallet'
import { TezosToolkit } from '@taquito/taquito'
import { Tzip12Module } from '@taquito/tzip12'
import { Tzip16Module } from '@taquito/tzip16'
import axios from 'axios'
import CookieLaw from 'vue-cookie-law'
export default {
  name: 'app',
  components: { CookieLaw },
  beforeMount() {
    const accessToken = this.$store.getters.accessToken
    if (accessToken) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
    }
    this.handleLogoutEvent = document.addEventListener('startLogoutSession', () => {
      console.info('starting logout session')
      this.$store.commit('clearSession')
      this.$router.push('/login')
    })
  },
  mounted() {
    if (this.$store.getters.wallet == null) {
      console.log('initializing wallet')
      this.initWallet()
    }
  },
  methods: {
    async initWallet() {
      try {
        console.log(`Connecting to tezos at ${process.env.VUE_APP_TEZOS_RPC}`)
        const tezos = new TezosToolkit(process.env.VUE_APP_TEZOS_RPC)
        tezos.addExtension(new Tzip16Module())
        tezos.addExtension(new Tzip12Module())

        const options = {
          name: 'pxl.games',
          iconUrl: 'https://www.pxl.games/img/logo-light.7a29fa0f.png',
          preferredNetwork: process.env.VUE_APP_TEZOS_NETWORK,
          eventHandlers: {
            [BeaconEvent.PAIR_INIT]: {
              handler: defaultEventCallbacks.PAIR_INIT,
            },
            [BeaconEvent.PAIR_SUCCESS]: {
              handler: defaultEventCallbacks.PAIR_SUCCESS,
            },
          },
        }
        const wallet = new BeaconWallet(options)
        const activeAccount = await wallet.client.getActiveAccount()
        const walletAddress = activeAccount ? await wallet.getPKH() : null

        if (walletAddress) {
          tezos.setWalletProvider(wallet)
          // const pxlEscrow = await wallet.at(process.env.VUE_APP_PXL_ESCROW, tzip16)
          // this.$store.commit('initializePxlEscrow', pxlEscrow)
        }

        this.$store.commit('initializeTezos', tezos)
        this.$store.commit('initializeWallet', wallet)
        this.$store.commit('initializeConnectedWalletAddress', walletAddress)
      } catch (e) {
        console.error('Unable to init taquito', e)
        // await new Promise((resolve) => setTimeout(resolve, 15000))
        // this.$router.go(0)
      }
    },
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'robots',
          content: process.env.VUE_APP_ENV === 'production' ? 'index, follow' : 'noindex, nofollow',
        },
      ],
    }
  },
}
</script>
<style scoped>
.Cookie__button {
  background: #45c0a7;
}
</style>
